import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class GalleryService {

	public request = new Subject()

	constructor() {}

	open(index: number) {
		if (Number.isInteger(index))
			this.request.next(index)
	}
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/gallery/gallery.service.ts